<template>
  <div class="d-flex flex-column" :class="wrapperClass">
    <v-tooltip top :disabled="!disabled">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <BaseButton
            :text="confirmText"
            rounded
            depressed
            :block="block"
            color="psorange"
            :height="String(buttonHeight)"
            :min-width="minWidth"
            :className="`font-20 font-weight-bold mb-4 ${confirmClass}`"
            :disabled="confirmDisabled"
            @click="$emit('confirm')"
          />
        </div>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
    <v-tooltip top :disabled="!disabled">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <BaseButton
            :text="dontMeetText"
            rounded
            outlined
            depressed
            :block="block"
            :height="String(buttonHeight)"
            :min-width="minWidth"
            :className="`font-20 font-weight-bold ${dontMeetClass}`"
            :disabled="disabled"
            @click="$emit('dont-meet')"
          />
        </div>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import BaseButton from "@/components/BaseComponents/BaseButton.vue";

export default {
  name: "EligibilityActions",
  components: {
    BaseButton,
  },
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    confirmDisabled: {
      type: Boolean,
      default: true,
    },
    confirmText: {
      type: String,
      default: "Confirm Eligibility",
    },
    dontMeetText: {
      type: String,
      default: "Don't meet eligibility",
    },
    tooltipText: {
      type: String,
      default: "Please read all before confirming.",
    },
    buttonHeight: {
      type: [String, Number],
      default: "68",
    },
    block: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: [String, Number],
      default: undefined,
    },
    wrapperClass: {
      type: String,
      default: "",
    },
    confirmClass: {
      type: String,
      default: "",
    },
    dontMeetClass: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: var(--v-psorange-base) !important;
  color: #272727 !important;
  opacity: 0.5 !important;
}
.theme--light.v-btn.v-btn--disabled.v-btn--outlined {
  opacity: 0.5 !important;
}
</style>
